import React from "react";
import "./PricePopup.css"; 

const PricePopup = ({ adultPrice, childPrice, onClose }) => {
  return (
    <div className="price-popup-overlay">
      <div className="price-popup">
        <h2>Buffet Prices</h2>
        <p>Adults: £{adultPrice.toFixed(2)}</p>
        <p>Children: £{childPrice.toFixed(2)}</p>
        <button onClick={onClose}>Got it!</button>
      </div>
    </div>
  );
};

export default PricePopup;
